export default "__VITE_ASSET__CXOjI7l9__ 500w";